<template>
  <div
    class="bar-container"
    :style="{ height: height + 'px' }"
    @mousedown="startDrag"
    @touchstart="startDrag"
  >
    <svg viewBox="0 0 100 1" preserveAspectRatio="none" class="bar-svg" ref="svg">
      <rect
        class="bar-background"
        x="0"
        y="0"
        width="100"
        height="1"
        rx="0.5"
        ry="0.5"
      />
      <rect
        class="bar-progress"
        x="0"
        y="0"
        :width="percentage * 100"
        height="1"
        rx="0.5"
        ry="0.5"
        :style="{ fill: color }"
      />
    </svg>
    <div class="bar-label">
      {{ humanizeActivity(currentValue) }}
    </div>
  </div>
</template>

<script>

export default {
  name: "InteractiveProgressBar",
  props: {
    value: { type: Number, required: true },
    max: { type: Number, default: 100 },
    clampTo: { type: Number, default: null }, // limite le drag sans changer le visuel
    height: { type: Number, default: 20 },
    color: { type: String, default: "#4CAF50" },
    step: { type: Number, default: 1 },
  },
  data() {
    return {
      dragging: false,
      currentValue: this.value
    };
  },
  watch: {
    value(val) {
      const stepped = Math.round(val / this.step) * this.step;
      this.currentValue = stepped;
    },
  },
  computed: {
    percentage() {
      return Math.min(this.currentValue / this.max, 1);
    }
  },
  methods: {
    startDrag(event) {
      this.dragging = true;
      this.updateValue(event);
      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.stopDrag);
      window.addEventListener("touchmove", this.onDrag);
      window.addEventListener("touchend", this.stopDrag);
    },
    onDrag(event) {
      if (this.dragging) {
        this.updateValue(event);
      }
    },
    stopDrag() {
      this.dragging = false;
      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("touchmove", this.onDrag);
      window.removeEventListener("touchend", this.stopDrag);
    },
    updateValue(event) {
      const svg = this.$refs.svg;
      const rect = svg.getBoundingClientRect();
      const clientX = event.touches?.[0]?.clientX ?? event.clientX;
      const x = clientX - rect.left;
      const ratio = Math.max(0, Math.min(x / rect.width, 1));
      let rawValue = ratio * this.max;

      // Appliquer l'arrondi au pas le plus proche
      const steppedValue = Math.round(rawValue / this.step) * this.step;
      const effectiveMax = (this.clampTo !== null) ? Math.min(this.max, this.clampTo) : this.max;
      const newValue = Math.min(effectiveMax, Math.max(0, steppedValue)); // clamp
      
      this.currentValue = newValue;
      this.$emit("input", newValue);
    },
    humanizeActivity(time) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      return `${hours} heures ${minutes} minutes`;
    }
  }
};
</script>

<style scoped>
.bar-container {
  width: 100%;
  position: relative;
  cursor: pointer;
  user-select: none;
  touch-action: none;
}

.bar-svg {
  width: 100%;
  height: 100%;
  display: block;
}

.bar-background {
  fill: #ddd;
}

.bar-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #333;
  pointer-events: none;
}
</style>
